module.exports = __webpack_public_path__ + "img/save.bf7292df.svg";